import React, { useState, useEffect } from "react";

const loadedImages = new Set(); // cache for URLs already loaded

export default function ImageWithLoader2({
  src,
  alt,
  style,
  className,
  placeholder,
  fadeDuration = 500, // ms
  blurAmount = 10,    // px
}) {
  const [loaded, setLoaded] = useState(false);
  const [shouldFade, setShouldFade] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (loadedImages.has(src)) {
      setLoaded(true);
      setShouldFade(false); // skip fade if seen before
    } else {
      setLoaded(false);
      setShouldFade(true); // fade only on first load
    }
  }, [src]);

  const handleLoad = () => {
    loadedImages.add(src);
    setLoaded(true);
  };

  const transitionStyle = {
    transition: shouldFade ? `opacity ${fadeDuration}ms ease` : "none",
    width: "100%",
    height: "100%",
    objectFit: "cover",
  };

  return (
    <div
      style={{
        position: "relative",
        overflow: "hidden",
        ...style,
      }}
      className={className}
    >
      {/* Placeholder + shimmer */}
      {!loaded && (
        <div
          style={{
            position: "absolute",
            inset: 0,
            backgroundImage: `url(${placeholder})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            filter: `blur(${blurAmount}px)`,
          }}
        >
          <div
            style={{
              position: "absolute",
              inset: 0,
              background:
                "linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.3) 50%, rgba(255,255,255,0) 100%)",
              animation: "shimmer 1.5s infinite",
            }}
          />
        </div>
      )}

      {/* Main image */}
      <img
        src={error ? placeholder : src}
        alt={alt}
        onLoad={handleLoad}
        onError={() => {
          setLoaded(true);
          setError(true);
        }}
        style={{
          ...transitionStyle,
          opacity: loaded ? 1 : 0,
          position: "relative",
          zIndex: 1,
        }}
      />

      {/* Shimmer keyframes */}
      <style>
        {`
          @keyframes shimmer {
            0% { transform: translateX(-100%); }
            100% { transform: translateX(100%); }
          }
          div[style*="shimmer"] {
            will-change: transform;
          }
        `}
      </style>
    </div>
  );
}
